import Head from "next/head";
import React from "react";
import CityDetailsComp from "../../../components/city-listing";
import HotelListing from "../../../components/hotelListing";
import { fetchHotelsList, fetchTypeDetails } from "../../../utils/api";

const TypeDetails = ({ placesTypeDetails, hotelList }) => {
  const seo = placesTypeDetails?.[0]?.seo;

  return (
    <>
      <Head>
        {placesTypeDetails?.[0]?.title && (
          <title>{placesTypeDetails?.[0]?.title}</title>
        )}

        {/* Meta Tags */}
        {seo?.description && (
          <meta name="description" content={seo?.description} />
        )}

        {/* Open Graph Tags */}
        {seo?.og_title && <meta property="og:title" content={seo?.og_title} />}
        {seo?.og_image && <meta property="og:image" content={seo?.og_image} />}

        {seo?.og_description && (
          <meta property="og:description" content={seo?.og_description} />
        )}
        {/* <meta
          property="og:url"
          content="https://www.example.com/trip/best-places-to-visit-in-pauri-garhwal"
        /> */}
        <meta property="og:type" content="website" />

        {/* Canonical Tag */}
        <link rel="canonical" href={seo?.canonical_tag} />
        {seo?.keywords && <meta name="keywords" content={seo?.keywords} />}
      </Head>
      <CityDetailsComp data={placesTypeDetails[0]} />
      <HotelListing
        hotelList={hotelList}
        placeName={
          placesTypeDetails[0]?.destination_city_name ||
          placesTypeDetails[0]?.cityName
        }
        // stateSlug={placesTypeDetails[0]?.stateSlug}
        // citySlug={placesTypeDetails[0]?.citySlug}
        // placeName={
        //   placesTypeDetails[0]?.destination_city_name ||
        //   placesTypeDetails[0]?.cityName
        // }
      />
    </>
  );
};

export default TypeDetails;

// export async function getServerSideProps(context) {
//   const { query, req } = context;
//   const isServer = req ? true : false;
//   const platform = isServer ? "server" : "client";

//   try {
//     const placesTypeDetails = await fetchTypeDetails(platform, query);

//     // Check if the data is valid
//     if (!placesTypeDetails || placesTypeDetails.length === 0) {
//       return {
//         notFound: true,
//       };
//     }

//     return {
//       props: {
//         placesTypeDetails,
//       },
//     };
//   } catch (error) {
//     // Handle the Axios 404 error by returning a 404 page
//     if (error.response && error.response.status === 404) {
//       return {
//         notFound: true,
//       };
//     }

//     // If the error is something else, you can log it or handle it differently
//     console.error("Unexpected error:", error);

//     return {
//       notFound: true,
//     };
//   }
// }

export async function getServerSideProps(context) {
  const { query, req } = context;
  const isServer = !!req;
  const platform = isServer ? "server" : "client";

  try {
    // Fetch place type details
    const placesTypeDetails = await fetchTypeDetails(platform, query);

    // Validate place type data
    if (!placesTypeDetails || placesTypeDetails.length === 0) {
      return {
        notFound: true,
      };
    }

    // Extract necessary parameters for hotel fetching
    const { stateSlug, citySlug } = query;

    // Fetch hotel data
    const hotelList = await fetchHotelsList(platform, stateSlug, citySlug);

    return {
      props: {
        placesTypeDetails,
        hotelList,
      },
    };
  } catch (error) {
    // Handle 404 errors explicitly
    if (error.response && error.response.status === 404) {
      return {
        notFound: true,
      };
    }

    console.error("Unexpected error:", error);
    return {
      notFound: true,
    };
  }
}
